<template>
  <div class="main">
    <div class="main_bg">
      <div>
        <contentMenu :index="4"></contentMenu>
      </div>
      <div class="banner">
        <img :src="imageurlMobile" style="width: 100%" />
      </div>
      <div class="main2-content">
        <contentRight2 :list="list2[0]"></contentRight2>
        <contentRight id="right" :list="list[0]"></contentRight>
      </div>
    </div>

    <div class="main_bg">
      <div class="banner" style="height: 700px;">
        <img :src="imageurl2Mobile" style="width: 100%;height: 700px;" />
        <div class="layout-center">
          <div class="title">四大核心系统</div>
          <div class="layout-flex">
            <div class="layout-flex-item" v-for="(item,index) in list3" :key="index">
              <div>
                <img class="item-img" :src="item.imageurl" />
              </div>
              <div class="item-title">{{item.title}}({{item.titleEn}})</div>
              <div class="item-dec">{{item.dec}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="divHeight"></div>
      <div class="main2-content">
        <contentRight id="left" :list="list[1]"></contentRight>
        <contentRight id="left" :list="list[2]"></contentRight>
        <div class="divHeight"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config";
import contentMenu from "./contentMenuMobile.vue";
import contentLeft from "./contentLeftMobile.vue";
import contentRight from "./contentRightMobile.vue";
import contentRight2 from "./contentRight2Mobile.vue";
export default {
  components: {
    contentMenu,
    contentLeft,
    contentRight,
    contentRight2
  },
  data() {
    return config.technology;
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 375px;
  margin: 0px auto;
  font-size: 14px;
}

.main_bg {
  width: 100%;
  min-width: 375px;
  background: #ffffff;
}

.main2-content {
  width: calc(100% - 0px);
  margin: 0px 0px;
}
.divHeight {
  height: 23px;
}

.banner {
  position: relative;
}

.layout-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .title {
    font-size: 24px;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
  }
  .layout-flex {
    width: 375px;
    height: 620px;
    padding: 30px 10px 30px 10px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: space-between;
    margin-left: auto;
    margin-right: auto;
    .layout-flex-item {
      width: 170px;
      height: 250px;
      background: #ffffff;
      opacity: 0.9;
    }

    .item-img {
      width: 100%;
    }
    .item-title {
      font-size: 12px;
      font-weight: 900;
      color: #343434;
      line-height: 21px;
      padding: 0px 10px;
    }
    .item-dec {
      font-size: 12px;
      font-weight: 400;
      color: #343434;
      line-height: 14px;
      padding: 5px 10px;
    }
  }
}

// #left /deep/ .layout-flex-1 {
//   box-shadow: -8px 8px 0px rgba(39, 131, 244, 0.2);
// }

// #right /deep/ .layout-flex-1 {
//   box-shadow: 8px 8px 0px rgba(39, 131, 244, 0.2);
// }
</style>
